// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lineNumberLink {
  color: #0d6efd !important;
  cursor: pointer;
}

.form-group {
  padding: 15px;
}

#container {
  position: relative;
}

#overlay {
  display: none;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2;
  display: block;
}

::ng-deep p-dropdown.p-dropdown_priority .p-dropdown-label {
  padding: 0 !important;
}

.line-table td {
  vertical-align: top;
}

.text-label {
  font-size: 18px;
}

.total-records {
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.total-records span {
  color: #4b5563; /* Warna lebih gelap untuk label */
}

.total-records .record-count {
  color: #3b82f6; /* Warna biru untuk angka */
  font-weight: 600;
}

.column-header-wrapper {
  display: flex;
  align-items: center;
  gap: 8px; /* jarak antara sortIcon dan filter */
}

.column-filter-wrapper.disabled {
  cursor: not-allowed;
}

.column-filter-wrapper.disabled .column-filter-inner {
  pointer-events: none;
  opacity: 0.5;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
